import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { utilFormatTime } from '../../util/format-time';

import { styles } from './ResendCodeTimer.styles';

export interface ResendCodeTimerProps {
  timeout?: number;
  onResend: () => Promise<void> | void;
  className?: string;
}

export function ResendCodeTimer({
  timeout = 60,
  onResend,
  className
}: ResendCodeTimerProps) {
  const slots = styles();
  const t = useTranslations();
  const [secondsLeft, setSecondsLeft] = useState(timeout);

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const handleResend = async () => {
    if (onResend) {
      await onResend();
      setSecondsLeft(timeout);
    }
  };

  return (
    <div className={slots.base({ className })}>
      {secondsLeft > 0 ? (
        <span className={slots.text()}>
          {t('authInput.resendIn', { time: utilFormatTime(secondsLeft) })}
        </span>
      ) : (
        <UiKitButtonBase
          className={slots.button()}
          onClick={handleResend}
          type="button"
          color="transparent"
        >
          {t('authInput.resendCode')}
        </UiKitButtonBase>
      )}
    </div>
  );
}
